import { POST_ENGAGEMENT, VIDEO_VIEWS } from '../../../../../../constants/campaigns'
import { PAGE_LIKES } from '../../../../../../constants/reusableObjectives'

export const isCarouselAdAllowed = lineItemObjective => {
  // Carousel ad is not supported for Post Engagement objective
  return (
    lineItemObjective !== POST_ENGAGEMENT &&
    // and also not supported for Page Likes objective
    lineItemObjective !== PAGE_LIKES
  )
}

export const isLineItemObjectiveVideoViews = lineItemObjective => {
  return lineItemObjective === VIDEO_VIEWS
}
